import React from 'react';

interface LiveDataIconProps {
  size?: number;
  className?: string;
}

const LiveDataIcon: React.FC<LiveDataIconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M2 14.6667H14" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M2.66667 5.58659C2.3 5.58659 2 5.88659 2 6.25325V11.9999C2 12.3666 2.3 12.6666 2.66667 12.6666H3.73332C4.09998 12.6666 4.39998 12.3666 4.39998 11.9999V6.25325C4.39998 5.88659 4.09998 5.58659 3.73332 5.58659H2.66667Z" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M7.46647 3.45996C7.0998 3.45996 6.7998 3.75996 6.7998 4.12663V12C6.7998 12.3666 7.0998 12.6666 7.46647 12.6666H8.53312C8.89979 12.6666 9.19979 12.3666 9.19979 12V4.12663C9.19979 3.75996 8.89979 3.45996 8.53312 3.45996H7.46647Z" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M12.2668 1.33333C11.9001 1.33333 11.6001 1.63333 11.6001 1.99999V12C11.6001 12.3667 11.9001 12.6667 12.2668 12.6667H13.3334C13.7001 12.6667 14.0001 12.3667 14.0001 12V1.99999C14.0001 1.63333 13.7001 1.33333 13.3334 1.33333H12.2668Z" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LiveDataIcon;